/*
https://www.facebook.com/
https://www.instagram.com/?hl=en
https://twitter.com/?lang=en

* Copyright (c) 2021. by N-Ach (Pvt) Ltd
*
* ╔═╗ ╔╗    ╔═══╗  ╔╗
* ║║╚╗║║    ║╔═╗║  ║║
* ║╔╗╚╝║    ║║ ║╠══╣╚═╗
* ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
* ║║ ║║║╚══╝║╔═╗║╚═╣║║║
* ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
*
* All rights reserved.
*
* This software is the confidential and proprietary information
* of N-Ach (Pvt) Ltd. ("Confidential Information"). You
* shall not disclose such Confidential Information and shall use
* it only in accordance with the terms of the license agreement
* you entered into with N-Ach (Pvt) Ltd.
*
*
* @Author Shalani Chethana
* @Date 24/01/2025
*/


import Footer3 from "./mainFooter";
import RedFooter from "./redFooter"
import FooterImage from "../../assets/images/img-footer.png";
import WaveBackground from "./waveBackground";

import Divider from '@mui/material/Divider';
import Styles from "./Footer.module.css";
import { Typography, Box } from "@mui/material";

function Footer() {
  return (<>
    <br />
    <>
      <WaveBackground />
      <div className={Styles.footerMainContainer}>

        <Footer3 />

        <Divider sx={{ color: "#ffff" }} />
        <Typography className={Styles.copyRightTxt}>Copy Right, 2025, N-ACH. All Rights Reserved.</Typography>

      </div>
    </>



  </>);
}

export default Footer;